/* ============================================================
   MONAT BLUE - BAN GOP (2026.07)
   1. Gop o so luong va nut ADD TO CART thanh mot hang
   2. Lien ket "Size guide" canh nhan SIZE
   3. Thanh mua hang dinh duoi (dien thoai, trang san pham)
   4. Thanh dieu huong co dinh duoi man hinh (dien thoai)
   5. Chon MAU tren the san pham (doi anh + doi hang size)
   6. Chon SIZE tren the san pham -> them thang vao gio
   7. Gap cac cot chan trang o dien thoai
   8. Muc menu cha (MAN / WOMAN) bam duoc de xem toan bo hang
   ============================================================ */
(function () {
  'use strict';

  var ICONS = {
    home: '<svg viewBox="0 0 24 24"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h14V9.5"/><path d="M9.5 20v-6h5v6"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24"><path d="M12 3.5 13.9 9 19.5 11l-5.6 2L12 18.5 10.1 13 4.5 11 10.1 9z"/></svg>',
    tag: '<svg viewBox="0 0 24 24"><path d="M3.5 11.5 11 4h8.5V12L12 19.5z"/><circle cx="15.7" cy="8.3" r="1.4"/></svg>',
    search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg>',
    bag: '<svg viewBox="0 0 24 24"><path d="M5.5 7.5h13l-1 12.5h-11z"/><path d="M9 7.5V6a3 3 0 0 1 6 0v1.5"/></svg>'
  };

  /* ---------- 1. Gop so luong + nut mua thanh mot hang ---------- */
  function buyRow() {
    var qty = document.querySelector('.product__info-container .product-form__quantity');
    var buttons = document.querySelector('.product__info-container .product-form__buttons');
    if (!qty || !buttons) return;
    if (buttons.classList.contains('mb-buyrow')) return;
    buttons.insertBefore(qty, buttons.firstChild);
    qty.classList.add('mb-qty');
    buttons.classList.add('mb-buyrow');
  }

  /* ---------- 2. Lien ket Size guide ---------- */
  function sizeGuide() {
    var groups = document.querySelectorAll('.product__info-container .product-form__input');
    var legend = null;
    for (var i = 0; i < groups.length; i++) {
      var l = groups[i].querySelector('legend.form__label') || groups[i].querySelector('.form__label');
      if (l && /size|kich c|ขนาด/i.test(l.textContent || '')) { legend = l; break; }
    }
    if (!legend || legend.querySelector('.mb-sizeguide')) return;

    var moTa = document.querySelector('.product__description');
    var tabs = document.querySelectorAll('.product .accordion');
    var tabSize = null;
    for (var j = 0; j < tabs.length; j++) {
      var s = tabs[j].querySelector('summary');
      if (s && /size/i.test(s.textContent || '')) { tabSize = tabs[j]; break; }
    }
    if (!moTa && !tabSize) return;

    var a = document.createElement('span');
    a.className = 'mb-sizeguide';
    a.setAttribute('role', 'button');
    a.setAttribute('tabindex', '0');
    a.textContent = 'Size guide';

    var moToi = function () {
      if (tabSize) {
        tabSize.setAttribute('open', 'true');
        tabSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (moTa) {
        moTa.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    a.addEventListener('click', moToi);
    a.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); moToi(); }
    });

    legend.appendChild(a);
  }

  /* ---------- 3. Thanh mua hang dinh duoi ---------- */
  function stickyBar() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var realButton = form.querySelector('button[name="add"]');
    if (!realButton) return;

    var titleEl = document.querySelector('.product__title h1, .product__title h2, .product__title');
    var priceEl = document.querySelector('.price--large, .product .price');
    if (!titleEl) return;

    injectStyles();

    var bar = document.createElement('div');
    bar.className = 'mb-stickybar';
    bar.setAttribute('aria-hidden', 'true');

    var info = document.createElement('div');
    info.className = 'mb-stickybar__info';

    var name = document.createElement('span');
    name.className = 'mb-stickybar__name';
    name.textContent = (titleEl.textContent || '').trim();
    info.appendChild(name);

    if (priceEl) {
      var price = document.createElement('span');
      price.className = 'mb-stickybar__price';
      price.textContent = (priceEl.textContent || '').replace(/\s+/g, ' ').trim();
      info.appendChild(price);
    }

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'mb-stickybar__cta';
    cta.textContent = (realButton.textContent || 'Add to cart').trim();
    cta.addEventListener('click', function () { realButton.click(); });

    bar.appendChild(info);
    bar.appendChild(cta);
    document.body.appendChild(bar);

    var sync = function () {
      cta.disabled = realButton.disabled;
      var label = realButton.querySelector('span');
      cta.textContent = ((label ? label.textContent : realButton.textContent) || '').trim();
    };
    sync();

    if (window.MutationObserver) {
      new MutationObserver(sync).observe(realButton, { attributes: true, childList: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('mb-has-buybar', show);
        });
      }, { threshold: 0 }).observe(realButton);
    }
  }

  function injectStyles() {
    if (document.getElementById('mb-stickybar-style')) return;
    var s = document.createElement('style');
    s.id = 'mb-stickybar-style';
    s.textContent = [
      '.mb-stickybar{position:fixed;left:0;right:0;bottom:0;z-index:6;display:flex;align-items:center;gap:1.2rem;',
      'padding:0.9rem 1.6rem calc(0.9rem + env(safe-area-inset-bottom));background:#fff;',
      'border-top:1px solid rgba(16,24,32,.12);transform:translateY(110%);transition:transform .32s cubic-bezier(.22,.61,.36,1);}',
      '.mb-stickybar.is-visible{transform:translateY(0);}',
      '.mb-stickybar__info{display:flex;flex-direction:column;min-width:0;flex:1 1 auto;}',
      '.mb-stickybar__name{font-size:1.25rem;font-weight:500;line-height:1.35;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#101820;}',
      '.mb-stickybar__price{font-size:1.25rem;font-weight:600;line-height:1.35;color:#101820;}',
      '.mb-stickybar__cta{flex:0 0 auto;min-height:4.4rem;padding:0 2.2rem;border:0;cursor:pointer;',
      'background:#1D4289;color:#fff;font-family:inherit;font-size:1.3rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;}',
      '.mb-stickybar__cta[disabled]{opacity:.45;cursor:not-allowed;}',
      '@media screen and (min-width:750px){.mb-stickybar{display:none;}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- 4. Thanh dieu huong duoi man hinh ---------- */
  function bottomNav() {
    if (document.querySelector('.mb-bottomnav')) return;
    var cfg = window.MB_NAV;
    if (!cfg || !cfg.items || !cfg.items.length) return;

    var duong = window.location.pathname;
    var nav = document.createElement('nav');
    nav.className = 'mb-bottomnav';
    nav.setAttribute('aria-label', 'Main');

    cfg.items.forEach(function (it) {
      var a = document.createElement('a');
      a.className = 'mb-bottomnav__item';
      a.href = it.url;

      if (it.key === 'sale') a.classList.add('mb-bottomnav__item--sale');

      var khop = it.key === 'home'
        ? (duong === '/' || /^\/[a-z-]{2,5}\/?$/.test(duong))
        : (it.url !== '/' && duong.indexOf(it.url.split('?')[0]) === 0);
      if (khop) a.classList.add('mb-bottomnav__item--active');

      var ic = document.createElement('span');
      ic.className = 'mb-bottomnav__icon';
      ic.innerHTML = ICONS[it.icon] || ICONS.tag;
      a.appendChild(ic);

      var lb = document.createElement('span');
      lb.className = 'mb-bottomnav__label';
      lb.textContent = it.label;
      a.appendChild(lb);

      if (it.key === 'cart') {
        var b = document.createElement('span');
        b.className = 'mb-bottomnav__badge';
        b.hidden = true;
        a.appendChild(b);
        theoDoiGio(b);
      }

      nav.appendChild(a);
    });

    document.body.appendChild(nav);
  }

  function theoDoiGio(badge) {
    var doc = function () {
      var n = 0;
      var bubble = document.querySelector('.cart-count-bubble span:not(.visually-hidden), .cart-count-bubble');
      if (bubble) n = parseInt((bubble.textContent || '').replace(/\D/g, ''), 10) || 0;
      if (n > 0) { badge.textContent = n > 99 ? '99+' : String(n); badge.hidden = false; }
      else { badge.hidden = true; }
    };
    doc();
    var host = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (host && window.MutationObserver) {
      new MutationObserver(doc).observe(host, { childList: true, subtree: true, characterData: true });
    }
    setTimeout(doc, 1200);
    document.addEventListener('mb:cart:added', doc);
  }

  /* ---------- 5. Chon mau tren the san pham ---------- */
  function doiMau(btn) {
    var hop = btn.closest('.mb-variants');
    if (!hop) return;
    var mau = btn.getAttribute('data-color');

    var oMau = hop.querySelectorAll('.mb-color');
    for (var i = 0; i < oMau.length; i++) {
      var on = oMau[i] === btn;
      oMau[i].classList.toggle('is-active', on);
      oMau[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    var nhom = hop.querySelectorAll('.mb-quicksize[data-color]');
    for (var j = 0; j < nhom.length; j++) {
      if (nhom[j].getAttribute('data-color') === mau) nhom[j].removeAttribute('hidden');
      else nhom[j].setAttribute('hidden', '');
    }

    var anh = btn.getAttribute('data-img');
    if (!anh) return;
    var the = btn.closest('.card-wrapper') || btn.closest('.card');
    if (!the) return;
    var img = the.querySelector('.card__media img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = anh;
  }

  /* ---------- 6. Chon size -> them thang vao gio ---------- */
  var SECTIONS = 'cart-drawer,cart-icon-bubble,cart-notification';

  function goc() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function capNhatGio(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      /* QUAN TRONG - dung xoa:
         Khi khach mo trang luc gio hang dang RONG, theme gan class
         "is-empty" len ca the <cart-drawer> lan .drawer__inner.
         Ham renderContents cua Dawn chi go class o .drawer__inner,
         khong go o the ngoai -> CSS van an danh sach san pham va
         gio hang truot ra se trang tron. Phai go bang tay o day. */
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');

      drawer.renderContents(data);
      return true;
    }

    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.renderContents === 'function') {
      notif.renderContents(data);
      return true;
    }
    return false;
  }

  function capNhatIcon(data) {
    if (!data || !data.sections || !data.sections['cart-icon-bubble']) return;
    var dich = document.getElementById('cart-icon-bubble');
    if (!dich) return;
    var moi = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
    var nguon = moi.querySelector('.shopify-section');
    if (nguon) dich.innerHTML = nguon.innerHTML;
  }

  function themVaoGio(btn, vid, url) {
    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(goc() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(vid), quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.status) throw new Error('khong them duoc');

        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        btn.disabled = false;
        setTimeout(function () { btn.classList.remove('is-done'); }, 1400);

        if (!capNhatGio(data)) capNhatIcon(data);

        document.dispatchEvent(new CustomEvent('mb:cart:added', { detail: { variantId: vid } }));
      })
      .catch(function () {
        window.location.href = url + '?variant=' + vid;
      });
  }

  /* ---------- 7. Gap cac cot chan trang o dien thoai ---------- */
  function footerAccordion() {
    var khoi = document.querySelectorAll('.footer__blocks-wrapper .footer-block--menu');
    if (!khoi.length || !window.matchMedia) return;

    var mq = window.matchMedia('(max-width: 749px)');

    function bam() {
      var b = this.closest('.footer-block');
      if (!b) return;
      var mo = b.classList.toggle('is-open');
      this.setAttribute('aria-expanded', mo ? 'true' : 'false');
    }

    function apDung() {
      for (var i = 0; i < khoi.length; i++) {
        var b = khoi[i];
        var h = b.querySelector('.footer-block__heading');
        var ds = b.querySelector('.footer-block__details-content');
        if (!h || !ds) continue;

        if (mq.matches) {
          if (b.classList.contains('mb-acc')) continue;
          b.classList.add('mb-acc');
          h.setAttribute('role', 'button');
          h.setAttribute('tabindex', '0');
          h.setAttribute('aria-expanded', 'false');
          var ic = document.createElement('span');
          ic.className = 'mb-acc__ic';
          ic.setAttribute('aria-hidden', 'true');
          h.appendChild(ic);
          h.addEventListener('click', bam);
          h.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bam.call(this); }
          });
        } else {
          b.classList.remove('mb-acc', 'is-open');
          h.setAttribute('aria-expanded', 'true');
        }
      }
    }

    apDung();
    if (mq.addEventListener) mq.addEventListener('change', apDung);
    else if (mq.addListener) mq.addListener(apDung);
  }

  /* ---------- 8. Muc menu cha bam duoc ----------
     Dawn dung <summary> cho muc co menu con, nen bam vao chu
     MAN / WOMAN chi mo menu xo xuong, khong vao duoc trang danh
     muc tong. Xu ly:
     - Man hinh lon: re chuot vao thi mo menu con, BAM vao chu thi
       chuyen trang. Bam bang BAN PHIM van giu hanh vi dong/mo cu
       de nguoi dung ban phim khong bi ket ngoai menu con.
     - Dien thoai: them dong "View all <ten muc>" o dau menu con,
       vi o day cham vao muc cha buoc phai mo menu con.

     LUU Y 1: theme co the dung mega-menu (.mega-menu__list) hoac
     menu xo xuong thuong (.header__submenu) -> phai do ca hai.

     LUU Y 2 - LOI DA SUA: truoc day menu dong NGAY khi chuot roi
     khoi chu MAN. Bang mega-menu nam thap hon thanh dieu huong mot
     khoang, nen khach ke chuot xuong toi bang thi menu da dong mat
     -> khong the chon duoc muc con nao. Nay cho tre 350ms truoc khi
     dong va huy lenh dong neu chuot quay lai.
     ------------------------------------------------------------ */
  var TRE_DONG = 350;

  function nhanXemTatCa() {
    var s = window.MB_XEMTATCA || '';
    if (!s || /translation missing/i.test(s)) return 'View all';
    return s;
  }

  function themDongXemTatCa(ul, info, nhan, clsDuPhong) {
    if (!ul || ul.querySelector('.mb-viewall')) return;
    var mau = ul.querySelector('a');
    var cls = mau && mau.className ? mau.className : clsDuPhong;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = info.url;
    a.className = cls + ' mb-viewall';
    a.textContent = nhan + ' ' + info.title;
    li.appendChild(a);
    ul.insertBefore(li, ul.firstChild);
  }

  function capNhatMucCha(li, info, nhan) {
    if (!li || !info || !info.url || !info.con) return;

    var d = li.querySelector('details');
    var s = li.querySelector('summary');
    if (!d || !s) return;

    if (!s.getAttribute('data-mb-cha')) {
      s.setAttribute('data-mb-cha', '1');

      var hen = null;

      li.addEventListener('mouseenter', function () {
        clearTimeout(hen);
        d.open = true;
      });

      li.addEventListener('mouseleave', function () {
        clearTimeout(hen);
        hen = setTimeout(function () { d.open = false; }, TRE_DONG);
      });

      s.addEventListener('click', function (e) {
        if (e.detail === 0) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = info.url;
      });
    }

    themDongXemTatCa(
      d.querySelector('.header__submenu, .mega-menu__list'),
      info,
      nhan,
      'header__menu-item list-menu__item link link--text focus-inset caption-large'
    );
  }

  function menuCha() {
    var mm = window.MB_MENU;
    if (!mm || !mm.length) return;
    var nhan = nhanXemTatCa();

    var tren = document.querySelectorAll('.header__inline-menu > ul > li');
    for (var i = 0; i < tren.length; i++) {
      capNhatMucCha(tren[i], mm[i], nhan);
    }

    var ngan = document.querySelector('.menu-drawer .menu-drawer__menu');
    if (!ngan) return;
    var con = ngan.children;
    for (var j = 0; j < con.length; j++) {
      var info = mm[j];
      if (!info || !info.url || !info.con) continue;
      var ul = con[j].querySelector('.menu-drawer__submenu .menu-drawer__menu');
      themDongXemTatCa(
        ul,
        info,
        nhan,
        'menu-drawer__menu-item link link--text list-menu__item focus-inset'
      );
    }
  }

  /* ---------- Bat su kien bam ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var oMau = e.target.closest('.mb-color');
    if (oMau) {
      e.preventDefault();
      e.stopPropagation();
      doiMau(oMau);
      return;
    }

    var btn = e.target.closest('.mb-quicksize__btn');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var hop = btn.closest('.mb-variants') || btn.closest('.mb-quicksize');
    var vid = btn.getAttribute('data-vid');
    var url = hop ? hop.getAttribute('data-url') : '/';
    if (!vid) return;

    themVaoGio(btn, vid, url || '/');
  }, true);

  /* ---------- Khoi dong ---------- */
  function init() {
    try { buyRow(); } catch (e) {}
    try { sizeGuide(); } catch (e) {}
    try { stickyBar(); } catch (e) {}
    try { bottomNav(); } catch (e) {}
    try { footerAccordion(); } catch (e) {}
    try { menuCha(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    try { buyRow(); } catch (e) {}
    try { sizeGuide(); } catch (e) {}
    try { footerAccordion(); } catch (e) {}
    try { menuCha(); } catch (e) {}
  });
})();
